import { shallowMount } from "@vue/test-utils";
import CustomLink from "@/components/core/CustomLink";

describe("CustomLink component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(CustomLink);
  });

  it("Renders del component CustomLink", () => {
    expect(wrapper).toBeDefined();
  });
});
